export default {
  from: 'vanaf',
  select: 'Ga naar de site',
  deal: 'aanbieding',
  deals: 'aanbiedingen',
  total: 'totaal',
  total_fr: '',
  pp: 'pp',
}
